import { render, staticRenderFns } from "./OpenMobileApp.vue?vue&type=template&id=6a528d86"
import script from "./OpenMobileApp.vue?vue&type=script&lang=js"
export * from "./OpenMobileApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports